import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import { useAPIEditJabatan } from "../api/api-edit-jabatan";
import { genElText } from "@components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";

const JabatanEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const {
    loading,
    data,
    setData,
    setError,
    fetchDataOrCreateNew,
    error,
    handleOnConfirm,
  } = useAPIEditJabatan({ onConfirmed });

  // use effect section

  useEffect(() => {
    if (visible) {
      setError({});
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
  }, [visible]);

  // genereate editor element section

  const elKode = genElText({
    field: "kode",
    name: "Kode",
    data,
    setData,
    error,
  });

  const elNama = genElText({
    field: "nama",
    name: "Nama",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "25rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={data.id && data.id > 0 ? "Edit Jabatan" : "Tambah Jabatan"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <div className="col-start-center relative h-100 gap-3">
        {elKode}
        {elNama}
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default JabatanEdit;
